import { ButtonLink, useLocale } from "@holigral/shared/routing"
import { useT } from "@/i18n"

/**
 * Final call to action. No-commitment line, then the single primary button.
 * Quiet by design — no pulsing glow (that was PromptJuggler's spark style).
 */
export default function Cta() {
  const { t } = useT("content")
  const locale = useLocale()

  return (
    <section className="flex flex-col items-center gap-6 px-6 py-16 text-center sm:py-24">
      <p className="max-w-md text-base text-muted-foreground sm:text-lg">
        {t("home.cta.text")}
      </p>
      <ButtonLink
        to="/$locale/auth"
        params={{ locale }}
        variant="brand"
        size="lg"
        className="px-8"
      >
        {t("home.cta.button")}
      </ButtonLink>
    </section>
  )
}
